import {
  exportExcel,
  getYeHuList,
  makePackage,
  downloadPackage,
} from '@/api/gddlysjgvehiclequalificationserv'

export default {
  state: {
    state_GdDlysjgVehicleQualification_ExportExcelResult: null,
    state_GdDlysjgVehicleQualification_GetYeHuListResult: null,
    state_GdDlysjgVehicleQualification_MakePackageResult: null,
    state_GdDlysjgVehicleQualification_DownloadPackageResult: null,
  },
  mutations: {
    SET_GDDLYSJGVEHICLEQUALIFICATION_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleQualification_ExportExcelResult = rst;
    },
    SET_GDDLYSJGVEHICLEQUALIFICATION_GETYEHULIST_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleQualification_GetYeHuListResult = rst;
    },
    SET_GDDLYSJGVEHICLEQUALIFICATION_MAKEPACKAGE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleQualification_MakePackageResult = rst;
    },
    SET_GDDLYSJGVEHICLEQUALIFICATION_DOWNLOADPACKAGE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleQualification_DownloadPackageResult = rst;
    },
  },
  actions: {
    GdDlysjgVehicleQualificationServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleQualificationServ_GetYeHuList({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getYeHuList(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_GETYEHULIST_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_GETYEHULIST_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleQualificationServ_MakePackage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        makePackage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_MAKEPACKAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_MAKEPACKAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleQualificationServ_DownloadPackage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        downloadPackage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_DOWNLOADPACKAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEQUALIFICATION_DOWNLOADPACKAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GdDlysjgVehicleQualification_ExportExcelResult: state => {
      return state.state_GdDlysjgVehicleQualification_ExportExcelResult;
    },
    get_GdDlysjgVehicleQualification_GetYeHuListResult: state => {
      return state.state_GdDlysjgVehicleQualification_GetYeHuListResult;
    },
    get_GdDlysjgVehicleQualification_MakePackageResult: state => {
      return state.state_GdDlysjgVehicleQualification_MakePackageResult;
    },
    get_GdDlysjgVehicleQualification_DownloadPackageResult: state => {
      return state.state_GdDlysjgVehicleQualification_DownloadPackageResult;
    },
  }
}